import jwt from "jsonwebtoken";

export default (token) => {
  if (!token) {
    return null;
  }

  return jwt.decode(token, process.env.GASTBY_JWT_SECRET);
};
